import { createSelector as ormSelector } from "redux-orm/lib/redux";
import orm from "../../models";
import getEntities from "../entities";
import { getScopeAttributes } from "../scoped_entities";

export const getConsultationReminders = ormSelector(orm, getEntities, (session) => {
  return session.consultationReminder.all().toModelArray().map(rem => {
    const { ref } = rem
    return { ...ref,
      emailTemplate: session.emailTemplate.withId(rem.emailTemplateId),
      ...getScopeAttributes(rem.scopeId, rem.scopeType, session)
    }
  })
})
